import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';

// import modules this module depends on
import angularTranslate from 'angular-translate';
import rnHttp from 'rhino/src/core/http/http.module';
import rnDevice from 'rhino/src/components/device/device.module';
import * as lfAdd from './lf-add.controller';

// import this modules components
import './lf-add.scss';

// define the module in one place and export the module name
export default angular.module('register.components.lfadd', [
  uiRouter,
  ngMaterial,
  angularTranslate,
  'rhino.core',
  rnHttp,
  rnDevice,
  'angulartics'
])
  .controller(lfAdd.name, lfAdd.default)
  .name;



// WEBPACK FOOTER //
// ./components/lf-add/lf-add.module.js